import { render, staticRenderFns } from "./UserSkills.vue?vue&type=template&id=b5a0e73a&"
import script from "./UserSkills.vue?vue&type=script&lang=js&"
export * from "./UserSkills.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports